// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"dfe6f236","790":"78f3f474"}[chunkId] + ".chunk.js";
};